import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=e08d0772&"
import script from "./Migration.vue?vue&type=script&lang=ts&"
export * from "./Migration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports